import { useGetClaimReason } from '../../screens/Claims/OverCharge/hooks/select-options/use-get-claim-reason';
import FormSelectBox from '../Inputs/FormSelectBox';

const OverChargeClaimReasonSelector = ({
  placeholder = 'Select Reason',
  label = 'Reason',
  rules = [],
  name,
  editMode,
  margin,
  onChange,
  value = '',
  className = '',
  tabIndex,
  disableValidation = false,
}) => {
  const { data: options = [], isLoading } = useGetClaimReason();

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
      value={value}
      className={className}
      tabIndex={tabIndex}
      disableValidation={disableValidation}
    />
  );
};

export default OverChargeClaimReasonSelector;
